import React from 'react'
import { LocaleCurrency as LocaleCurrencyComponent, USD } from 'components/FormatPrice'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import ProductPrintConnector, {
  ConnectorProps as ProductPrintProps,
} from '../../../connectors/ProductsPrint'
import { BlackBox, LinkButton, Column, Price } from '../../styles/products'
import classNames from 'classnames'

const PrintForSaleComponent = (
  props: ProductPrintProps
): React.ReactElement<React.ComponentProps<any>, any> | null => {
  const {
    clickAddToCart,
    totalPriceInCentsOfSelectedOptions,
    selectedProduct: { print },
    selectedProductSku,
  } = props
  const { listPrice } = print

  return (
    <BlackBox data-type='print'>
      <Column align='start'>
        <h4 className='defaultTypographyH4'>
          <Price>
            <LocaleCurrencyComponent
              price={convertFromCentsToDollars(listPrice + totalPriceInCentsOfSelectedOptions)}
            />
            <USD />
          </Price>
        </h4>
      </Column>

      <Column mr={2}>
        <LinkButton
          data-button='add-to-cart'
          onClick={(ev: React.SyntheticEvent<HTMLLinkElement>) => {
            ev.preventDefault()
            clickAddToCart({ sku: selectedProductSku, promoCode: '' })
          }}
          title='Add print to cart'
        >
          <p
            className={classNames('defaultTypographyCtaLarge', 'defaultTextBold')}
            style={{ color: '#ffffff', margin: 0 }}
          >
            Add to Cart
          </p>
        </LinkButton>
      </Column>
    </BlackBox>
  )
}

export default ProductPrintConnector(PrintForSaleComponent)
